import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { militaryContactView_template } from "../components/templates/militaryContactView_template";

declare var ko: any;
declare var page: any;

export class military_contact_view extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected contactView: militaryContactView_template;

    protected getModuleName() {
        return "military_contact_view";
    }

    buildContent(): Array<Element> {
        this.contactView = new militaryContactView_template("military_contact_view", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Military Contact");

        return [this.contactView.build()];
    }

    public fillPage(): void {
        this.getContact();
    }

    protected getContact(): void {
        this.loadingIn(this.contactView.builtTemplate);
        let usrReq_url = "/api/brand/" + this.getBrandId() + "/military-base-guides/contacts/get/" + this.getContactId() + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({})]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetContactReturn;
        this.XHRHdl.execute();
    }

    protected onGetContactReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.contactView.setContact(responseParsed.contact, responseParsed.usStates || {});
                obj.contactView.setReferencedHelpServices(responseParsed.referencedHelpServices || []);
                obj.contactView.setReferencedBases(responseParsed.referencedBases || []);
            });
            obj.loadingOut(obj.contactView.builtTemplate);
        };
    }

    protected cancel(): void {
        page("/brand/" + this.getBrandId() + "/military-base-guides/contacts");
    }

    protected editContact(): void {
        page("/brand/" + this.getBrandId() + "/military-base-guides/contacts/edit/" + this.getContactId());
    }

    protected viewReferencedHelpService(helpService): void {
        if (helpService && helpService.idBase) {
            page("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + helpService.idBase);
        }
    }

    protected viewReferencedBase(base): void {
        if (base && base.id) {
            page("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + base.id);
        }
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    public getContactId(): number {
        return Number(this.getVnAppZone().app.params.id);
    }

    public viewContactOnSite(path: string): void {
        this.openPathOnWebsite(path);
    }

    protected openPathOnWebsite(path: string): void {
        if (!path) {
            return;
        }

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        const hostnameParts = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if (hostnameParts.length == 3) {
            if (hostnameParts[0] != "emakicms") {
                urlBegin += hostnameParts[0] + ".";
            } else {
                isLocal = true;
            }
        }

        for (let i = 0; i < userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {
                const url = urlBegin + userBrands[i].domain.replace("www.", "") + (isLocal ? ("." + hostnameParts[2]) : "") + path;
                const element = document.createElement("a");
                element.setAttribute("href", url);
                element.setAttribute("target", "_blank");
                element.style.display = "none";
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_contact_view.ts